import { createApp } from 'vue';
import AviToWavConverter from '@/Components/AviToWavConverter.vue';
import '@styles/app.css';

createApp(AviToWavConverter).mount('#avi-to-wav-converter');
